(function () {

  if (location.href.includes('black-friday')) {
    localStorage.setItem('gff-black-friday-preview', Date.now());
  }

  const isBlackFriday = localStorage.getItem('gff-black-friday-preview');
  if (isBlackFriday) {
    document.documentElement.classList.add('gff-black-friday');
  }

  const standardBundle = '6 Week Subscription';
  const blackFridayBundle = 'Black Friday Offer - 6 Week Subscription';
  const preferredBundle = isBlackFriday ? blackFridayBundle : standardBundle;

  function filterSellingPlans () {
    if (typeof _RSConfig === 'undefined' || typeof RS === 'undefined' && document.querySelector('.gff-black-friday-preview-message')) {
      return requestAnimationFrame(filterSellingPlans);
    }

    sessionStorage['gffSellingPlan'] = sessionStorage['appstleSubscriptionConfig'];
    sessionStorage['gffSellingPlanConfig'] = JSON.stringify(_RSConfig);

    RS.Config.sellingPlansJson = [
      RS.Config.sellingPlansJson.find(plan => plan.frequencyName === preferredBundle)
    ];
    _RSConfig.product.selling_plan_groups[0].selling_plans = [
      _RSConfig.product.selling_plan_groups[0].selling_plans.find(plan => plan.name === preferredBundle)
    ];

    sessionStorage['appstleSubscriptionConfig'] = JSON.stringify(RS.Config);
  }

  location.href.includes('products') && filterSellingPlans();

})();
